<template>
	<h1 class="text-4xl text-center text-white font-header sm:text-left sm:text-5xl md:text-6xl">
	                Hello I'm Daniel Hagen!
	              </h1>
</template>
